import React from 'react';
import {View, Image, StyleSheet} from 'react-native';

interface WaveHeaderProps {
  showLogo?: boolean;
  height?: number;
}

const WaveHeader: React.FC<WaveHeaderProps> = ({showLogo = true, height = 200}) => {
  return (
    <View style={[stijlen.container, {height}]}>
      <View style={[stijlen.gradientLayer, stijlen.purpleLayer]} />
      {/* Een paar laagjes over elkaar voor dieptezicht */}
      <View style={[stijlen.gradientLayer, stijlen.blueLayer]} />
      <View style={[stijlen.gradientLayer, stijlen.blueOverlay]} />

      <View style={stijlen.waveContainer}>
        {/* De witte golf onderaan. Zorgt voor dat lekkere 'liquid' effect. */}
        <View style={stijlen.wave} />
      </View>

      {showLogo && (
        <View style={stijlen.logoContainer}>
          <Image
            source={require('../assets/logo.png')}
            style={stijlen.logo}
            resizeMode="contain"
          />
        </View>
      )}
    </View>
  );
};

const stijlen = StyleSheet.create({
  container: {
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  gradientLayer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  purpleLayer: {
    backgroundColor: '#7B3FF2',
  },
  blueLayer: {
    backgroundColor: '#4A90E2',
    opacity: 0.5,
  },
  blueOverlay: {
    backgroundColor: '#5A7FE2',
    opacity: 0.3,
  },
  waveContainer: {
    position: 'absolute',
    bottom: -1,
    left: 0,
    right: 0,
    height: 50,
  },
  wave: {
    width: '100%',
    height: '100%',
    backgroundColor: '#F5F5F5',
    borderTopLeftRadius: 60,
    borderTopRightRadius: 60,
  },
  logoContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 25,
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    width: 120,
    height: 120,
  },
});

export default WaveHeader;
